import React from "react";
import classNames from "classnames";

// Components
import { Check, Close } from "@octopus-investments/deep-sea-components/Icons";

// Styles
import "./PasswordChecks.scss";

export default function PasswordChecks({ password }) {
  function PasswordCheckRow({ passed, text }) {
    const passwordCheckClasses = classNames("tick-icon", passed ? "tick-icon-on" : "tick-icon-off");
    return (
      <li>
        <span className={passwordCheckClasses}>{passed ? <Check /> : <Close />}</span>
        {text}
      </li>
    );
  }

  return (
    <div className="password-checks-block">
      <span>Your password must contain:</span>
      <ul>
        <PasswordCheckRow passed={password.length >= 14} text="14 characters or more" />
        <PasswordCheckRow passed={password.match(/[a-z]/)} text="At least one lower case letter" />
        <PasswordCheckRow passed={password.match(/[A-Z]/)} text="At least one upper case letter" />
        <PasswordCheckRow passed={password.match(/\d/)} text="At least one number" />
      </ul>
    </div>
  );
}
